import { Heading } from "@oysterhr/ui"
import { PropsWithChildren, ReactNode, useState } from "react"
import { Back } from "../Back"

const wrapperClass = `
  p-2 md:p-20 md:pt-12 pb-40 text-center w-full h-full
  min-h-screen bg-gray-100 text-black
`

export const NarrowPageLayout = ({ children }: PropsWithChildren<unknown>) => {
  return <div className={wrapperClass}>{children}</div>
}

const Title = ({ children }: PropsWithChildren<unknown>) => (
  <Heading size="3xl" className="mt-8">
    {children}
  </Heading>
)
const Subtitle = ({ children }: PropsWithChildren<unknown>) => (
  <p className="mt-4 text-md text-gray-400">{children}</p>
)

type BackLinkProps = {
  link: string
  text: string
}

const BackLink = ({ link, text }: BackLinkProps) => (
  <Back to={link} mobileVisible noMargin>
    {text}
  </Back>
)

type BackLinkWithConfirmationProps = {
  link: string
  text: string
  onClick?: () => void
  confirmationModal: (props: { setShowModal: (show: boolean) => void; link: string }) => ReactNode
}

const BackLinkWithConfirmation = ({
  link,
  text,
  confirmationModal,
  onClick,
}: BackLinkWithConfirmationProps) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      {showModal && confirmationModal({ setShowModal, link })}
      <Back
        onClick={() => {
          onClick?.()
          setShowModal(true)
        }}
        mobileVisible
        noMargin
      >
        {text}
      </Back>
    </>
  )
}

NarrowPageLayout.Title = Title
NarrowPageLayout.Subtitle = Subtitle
NarrowPageLayout.BackLink = BackLink
NarrowPageLayout.BackLinkWithConfirmation = BackLinkWithConfirmation
